import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PTooltipDirective } from './p-tooltip.directive';
import {
    MatTooltipDefaultOptions,
    MAT_TOOLTIP_DEFAULT_OPTIONS
} from '@angular/material/tooltip';

const customTooltipDefaults: MatTooltipDefaultOptions = {
    showDelay: 0,
    hideDelay: 0,
    touchendHideDelay: 0,
    disableTooltipInteractivity: true
};

@NgModule({
    imports: [CommonModule, MatTooltipModule],
    declarations: [PTooltipDirective],
    exports: [PTooltipDirective, MatTooltipModule],
    providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: customTooltipDefaults }]
})
export class PTooltipModule {}
